var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { MasterEvent } from "../MasterEvent";
import { Market } from "../Market";
import { observable, action, computed } from "mobx";
export var ItemState;
(function (ItemState) {
    ItemState[ItemState["loading"] = 0] = "loading";
    ItemState[ItemState["available"] = 1] = "available";
    ItemState[ItemState["unavailable"] = 2] = "unavailable";
})(ItemState || (ItemState = {}));
export class PickedEvent {
    constructor(source) {
        this.MasterEventID = source.MasterEventID;
        this.HasLivestream = !!source.HasLivestream;
        this.EventID = source.EventID;
        this.IsOutright = source.IsOutright;
        this.IsQA = source.IsQA;
        this.LineTypeID = source.LineTypeID;
        this.state = ItemState.loading;
        this.navHandler = window["Application"];
        this.Link = source.Link;
        this.Mode = source.Mode ? source.Mode : undefined;
        this.event = source.event ? new MasterEvent(source.event) : undefined;
        this.market = source.market ? new Market(source.market) : undefined;
    }
    upsertEvent(masterEvent) {
        this.event
            ? this.event.update(masterEvent)
            : (this.event = masterEvent);
    }
    upsertMarket(market) {
        if (this.event) {
            this.event.upsertMarket(market);
        }
    }
    removeMarkets(marketIds) {
        if (this.event) {
            this.event.removeMarkets(marketIds);
        }
    }
    deleteEvent() {
        this.event = undefined;
    }
    updateMarket(market) {
        this.market = market;
    }
    /* istanbul ignore next */
    setState(state) {
        this.state = state;
    }
    get getLink() {
        return this.event
            && this.event.isLive
            && this.navHandler
            && this.navHandler.Navigation
            ? this.navHandler.Navigation.getLiveEventLink(this.event.id)
            : this.Link;
    }
}
__decorate([
    observable,
    __metadata("design:type", MasterEvent)
], PickedEvent.prototype, "event", void 0);
__decorate([
    observable,
    __metadata("design:type", Market)
], PickedEvent.prototype, "market", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], PickedEvent.prototype, "state", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MasterEvent]),
    __metadata("design:returntype", void 0)
], PickedEvent.prototype, "upsertEvent", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], PickedEvent.prototype, "deleteEvent", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Market]),
    __metadata("design:returntype", void 0)
], PickedEvent.prototype, "updateMarket", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], PickedEvent.prototype, "setState", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PickedEvent.prototype, "getLink", null);
//# sourceMappingURL=PickedEvent.js.map